module.exports = __webpack_public_path__ + "img/p1.325490b9.png";